module.exports = __webpack_public_path__ + "static/login-7ad8d71682745699d2ce8ee3b9099d56.png";